import moment from "moment-timezone";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseConfig";
import {
    FaMusic, FaVideo, FaMicrophoneAlt, FaUsers, FaCameraRetro, FaBullhorn,
    FaHandshake, FaPlaneDeparture, FaTheaterMasks, FaChartBar, FaChalkboardTeacher,
    FaUtensils, FaGuitar, FaTruckLoading, FaDoorOpen, FaHandsHelping, FaExchangeAlt,
    FaGlassCheers, FaShuttleVan, FaPodcast, FaQuestion, FaMicrophone, FaUserAltSlash, FaBed, FaTaxi, FaHotel,
    FaShip,
    FaBus, FaCar, FaTrain,
    FaTshirt, FaComments, FaPaintBrush, FaWalking,
    FaBorderNone, FaUmbrellaBeach,
    FaCheckCircle, FaQuestionCircle, FaTimesCircle, FaHourglassHalf, FaCalendarAlt, FaPauseCircle, FaFileAlt,
    FaTv, FaBroadcastTower, FaCompactDisc, FaPen, FaBriefcase, FaTrophy, FaRocket, FaCogs
} from "react-icons/fa";
import { VscMap } from "react-icons/vsc";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";


// Rounded to whole months so the cache key (and the offline copy) stays the same all month
export const getCalendarRange = () => {
    return {
        start: moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'),
        end: moment().add(1, 'year').endOf('month').format('YYYY-MM-DD'),
    };
}

export const getUpcomingCalendarRange = () => {
    return {
        start: moment().format('YYYY-MM-DD'),
        end: moment().add(1, 'year').format('YYYY-MM-DD'),
    };
}



export const ActivityType = {
    BREAKFAST: "BREAKFAST",
    REHEARSAL: "REHEARSAL",
    GETIN: "GETIN",
    LOADIN: "LOADIN",
    LUNCH: "LUNCH",
    SOUND_CHECK: "SOUND_CHECK",
    MEET_AND_GREET: "MEET_AND_GREET",
    SUPPORT: "SUPPORT",
    CHANGE_OVER: "CHANGE_OVER",
    DOORS: "DOORS",
    CURFEW: "CURFEW",
    ONSTAGE: "ONSTAGE",
    OFFSTAGE: "OFFSTAGE",
    SHOW: "SHOW",
    GETOUT: "GETOUT",
    AFTERPARTY: "AFTERPARTY",
    TRANSPORT: "TRANSPORT",
    NIGHTLINER: "NIGHTLINER",
    FLIGHT: "FLIGHT",
    FERRY: "FERRY",
    TRAIN: "TRAIN",
    CAR: "CAR",
    BUS: "BUS",
    TAXI: "TAXI",
    INTERVIEW: "INTERVIEW",
    PHOTOS: "PHOTOS",
    VIDEO: "VIDEO",
    DINNER: "DINNER",
    WORKSHOP: "WORKSHOP",
    OTHER: "OTHER",
    OTHER_ARTIST: "OTHER_ARTIST",
    CHANGE_CLOTHES: "CHANGE_CLOTHES",
    BRIEFING: "BRIEFING",
    MAKEUP: "MAKEUP",
    WALK: "WALK",
    MIC_SETUP: "MIC_SETUP",
    BUSCALL: "BUSCALL",
    NOTE: "NOTE",
    ACCOMMODATION: "ACCOMMODATION"
}

export const ActivityTypes = [
    { value: "FLIGHT", name: "Flight", icon: <FaPlaneDeparture />, category: "Transportation" },
    { value: "TRANSPORT", name: "Transport", icon: <FaShuttleVan />, category: "Transportation" },
    { value: "NIGHTLINER", name: "Nightliner", icon: <FaBus />, category: "Transportation" },
    { value: "FERRY", name: "Ferry", icon: <FaShip />, category: "Transportation" },
    { value: "TRAIN", name: "Train", icon: <FaTrain />, category: "Transportation" },
    { value: "CAR", name: "Car", icon: <FaCar />, category: "Transportation" },
    { value: "BUS", name: "Bus", icon: <FaBus />, category: "Transportation" },
    { value: "BUSCALL", name: "Bus Call", icon: <FaBus />, category: "Transportation" },
    { value: "TAXI", name: "Taxi", icon: <FaTaxi />, category: "Transportation" },
    { value: "WALK", name: "Walk", icon: <FaWalking />, category: "Transportation" },

    { value: "BREAKFAST", name: "Breakfast", icon: <FaUtensils />, category: "Meals" },
    { value: "LUNCH", name: "Lunch", icon: <FaUtensils />, category: "Meals" },
    { value: "DINNER", name: "Dinner", icon: <FaUtensils />, category: "Meals" },

    { value: "GETIN", name: "Get-in", icon: <FaTruckLoading />, category: "Show & Venue" },
    { value: "LOADIN", name: "Load-in", icon: <FaTruckLoading />, category: "Show & Venue" },
    { value: "SOUND_CHECK", name: "Sound Check", icon: <FaMicrophoneAlt />, category: "Show & Venue" },
    { value: "MIC_SETUP", name: "Mic Setup", icon: <FaMicrophone />, category: "Show & Venue" },
    { value: "DOORS", name: "Doors", icon: <FaDoorOpen />, category: "Show & Venue" },
    { value: "SUPPORT", name: "Support", icon: <FaUsers />, category: "Show & Venue" },
    { value: "CHANGE_OVER", name: "Change over", icon: <FaExchangeAlt />, category: "Show & Venue" },
    { value: "ONSTAGE", name: "On stage", icon: <FaTheaterMasks />, category: "Show & Venue" },
    { value: "OTHER_ARTIST", name: "Other Artist", icon: <FaUsers />, category: "Show & Venue" },
    { value: "OFFSTAGE", name: "Off stage", icon: <FaUserAltSlash />, category: "Show & Venue" },
    { value: "GETOUT", name: "Get-out", icon: <FaTruckLoading />, category: "Show & Venue" },
    { value: "CURFEW", name: "Curfew", icon: <FaChartBar />, category: "Show & Venue" },
    { value: "MEET_AND_GREET", name: "Meet & Greet", icon: <FaHandsHelping />, category: "Show & Venue" },
    { value: "AFTERPARTY", name: "Afterparty", icon: <FaGlassCheers />, category: "Show & Venue" },

    { value: "INTERVIEW", name: "Interview", icon: <FaMicrophone />, category: "Media & Press" },
    { value: "PHOTOS", name: "Photos", icon: <FaCameraRetro />, category: "Media & Press" },
    { value: "VIDEO", name: "Video", icon: <FaVideo />, category: "Media & Press" },
    { value: "BRIEFING", name: "Briefing", icon: <FaComments />, category: "Media & Press" },

    { value: "ACCOMMODATION", name: "Hotel", icon: <FaHotel />, category: "General" },
    { value: "REHEARSAL", name: "Rehearsal", icon: <FaGuitar />, category: "General" },
    { value: "WORKSHOP", name: "Workshop", icon: <FaChalkboardTeacher />, category: "General" },
    { value: "CHANGE_CLOTHES", name: "Change Clothes", icon: <FaTshirt />, category: "General" },
    { value: "MAKEUP", name: "Makeup", icon: <FaPaintBrush />, category: "General" },
    { value: "NOTE", name: "Note", icon: <FaFileAlt />, category: "General" },
    { value: "OTHER", name: "Other", icon: <FaBorderNone />, category: "General" }
];



export const EventType = {
    CONCERT: "CONCERT",
    FESTIVAL: "FESTIVAL",
    SPORTS: "SPORTS",
    PUBLIC: "PUBLIC",
    SHOWCASE: "SHOWCASE",
    CONFERENCE: "CONFERENCE",
    WORKSHOP: "WORKSHOP",
    MEETING: "MEETING",
    TRAVEL_DAY: "TRAVEL_DAY",
    OFF_DAY: "OFF_DAY",
    REHEARSAL_DAY: "REHEARSAL_DAY",
    PRESS_DAY: "PRESS_DAY",
    PHOTO_SHOOT: "PHOTO_SHOOT",
    STUDIO: "STUDIO",
    VACATION: "VACATION",
    PRE_PRODUCTION: "PRE_PRODUCTION",
    TV_APPEARANCE: "TV_APPEARANCE",
    RADIO: "RADIO",
    MUSIC_VIDEO: "MUSIC_VIDEO",
    SIGNING: "SIGNING",
    CORPORATE: "CORPORATE",
    AWARD_SHOW: "AWARD_SHOW",
    RELEASE: "RELEASE",
    OTHER: "OTHER",
}

export const EventTypeGroup = {
    LIVE:       { key: 'LIVE',       name: 'Live / Jobb',           color: '#4caf50', icon: <FaMusic /> },
    PROMO:      { key: 'PROMO',      name: 'Promo & Media',         color: '#ab47bc', icon: <FaCameraRetro /> },
    PRODUCTION: { key: 'PRODUCTION', name: 'Produksjon & Planlegging', color: '#ff9800', icon: <FaCogs /> },
    OFF:        { key: 'OFF',        name: 'Reise & Fri',           color: '#78909c', icon: <FaPlaneDeparture /> },
    OTHER:      { key: 'OTHER',      name: 'Annet',                 color: '#9e9e9e', icon: <FaQuestion /> },
};

export const EventTypes = [
    // Live / Jobb
    { value: "CONCERT", name: "Concert", icon: <FaMusic />, group: "LIVE" },
    { value: "FESTIVAL", name: "Festival", icon: <FaMusic />, group: "LIVE" },
    { value: "SHOWCASE", name: "Showcase", icon: <FaTheaterMasks />, group: "LIVE" },
    { value: "PUBLIC", name: "Public Event", icon: <FaUsers />, group: "LIVE" },
    { value: "SPORTS", name: "Sports Event", icon: <FaMusic />, group: "LIVE" },
    { value: "REHEARSAL_DAY", name: "Rehearsal Day", icon: <FaGuitar />, group: "LIVE" },
    { value: "CORPORATE", name: "Corporate", icon: <FaBriefcase />, group: "LIVE" },
    { value: "AWARD_SHOW", name: "Award Show", icon: <FaTrophy />, group: "LIVE" },
    // Promo & Media
    { value: "PRESS_DAY", name: "Press Day", icon: <FaMicrophoneAlt />, group: "PROMO" },
    { value: "PHOTO_SHOOT", name: "Photo Shoot", icon: <FaCameraRetro />, group: "PROMO" },
    { value: "TV_APPEARANCE", name: "TV Appearance", icon: <FaTv />, group: "PROMO" },
    { value: "RADIO", name: "Radio", icon: <FaBroadcastTower />, group: "PROMO" },
    { value: "MUSIC_VIDEO", name: "Music Video", icon: <FaVideo />, group: "PROMO" },
    { value: "SIGNING", name: "Signing / Fan Meet", icon: <FaPen />, group: "PROMO" },
    { value: "RELEASE", name: "Release Event", icon: <FaRocket />, group: "PROMO" },
    
    // Produksjon & Planlegging
    { value: "PRE_PRODUCTION", name: "Pre-Production", icon: <FaCogs />, group: "PRODUCTION" },
    { value: "STUDIO", name: "Studio", icon: <FaMicrophone />, group: "PRODUCTION" },
    { value: "WORKSHOP", name: "Workshop", icon: <FaChalkboardTeacher />, group: "PRODUCTION" },
    { value: "MEETING", name: "Meeting", icon: <FaHandshake />, group: "PRODUCTION" },
    { value: "CONFERENCE", name: "Conference", icon: <FaBullhorn />, group: "PRODUCTION" },
    
    // Reise & Fri
    { value: "TRAVEL_DAY", name: "Travel Day", icon: <FaPlaneDeparture />, group: "OFF" },
    { value: "OFF_DAY", name: "Off Day", icon: <FaBed />, group: "OFF" },
    { value: "VACATION", name: "Vacation", icon: <FaUmbrellaBeach />, group: "OFF" },
    
    // Annet
    { value: "OTHER", name: "Other", icon: <FaQuestion />, group: "OTHER" },
];

/** Get the group color for an event type */
export const getEventGroupColor = (type) => {
    const eventType = EventTypes.find(t => t.value === type);
    const groupKey = eventType?.group || 'OTHER';
    return EventTypeGroup[groupKey]?.color || '#9e9e9e';
};

/** Get the group key for an event type */
export const getEventGroup = (type) => {
    const eventType = EventTypes.find(t => t.value === type);
    return eventType?.group || 'OTHER';
};



export const EventStatus = {
    PENDING: "PENDING",
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
    POSTPONED: "POSTPONED",
    RESCHEDULED: "RESCHEDULED",
    ON_HOLD: "ON_HOLD",
    DRAFT: "DRAFT",
}

export const EventStatuses = [
    { value: "PENDING", name: "Pending", icon: <FaMusic /> },
    { value: "CONFIRMED", name: "Confirmed", icon: <FaMusic /> },
    { value: "CANCELLED", name: "Cancelled", icon: <FaMusic /> },
    { value: "POSTPONED", name: "Postponed", icon: <FaMusic /> },
    { value: "RESCHEDULED", name: "Rescheduled", icon: <FaMusic /> },
    { value: "ON_HOLD", name: "On Hold", icon: <FaMusic /> },
    { value: "DRAFT", name: "Draft", icon: <FaMusic /> },
    // ✅ Additional Alternatives
];



export const ActivityStatus = {
    CONFIRMED: "CONFIRMED",
    TBC: "TBC",
    PENDING: "PENDING",
    CANCELLED: "CANCELLED",
    POSTPONED: "POSTPONED",
    RESCHEDULED: "RESCHEDULED",
    ON_HOLD: "ON_HOLD",
    DRAFT: "DRAFT",
}

export const ActivityStatuses = [
    { value: "CONFIRMED", name: "Confirmed", icon: <FaCheckCircle color="green" /> },
    { value: "TBC", name: "TBC", icon: <FaQuestionCircle color="orange" /> },
    { value: "PENDING", name: "Pending", icon: <FaHourglassHalf color="orange" /> },
    { value: "CANCELLED", name: "Cancelled", icon: <FaTimesCircle color="red" /> },
    { value: "POSTPONED", name: "Postponed", icon: <FaCalendarAlt color="orange" /> },
    { value: "RESCHEDULED", name: "Rescheduled", icon: <FaCalendarAlt color="#2196f3" /> },
    { value: "ON_HOLD", name: "On Hold", icon: <FaPauseCircle color="grey" /> },
    { value: "DRAFT", name: "Draft", icon: <FaFileAlt color="grey" /> },
];


export function printName(user, allUsers) {
    let printedName = "";
    if (user.firstName) {
        printedName = `${user.firstName}`.trim();
        if (allUsers != null) {
            allUsers.forEach((selectedUser) => {
                if (selectedUser.id !== user.id && selectedUser.firstName === user.firstName) {
                    printedName = `${user.firstName} ${user.lastName || ""}`.trim();
                }
            });
        }
    } else {
        printedName = `${user.email}`;
    }
    return printedName;
}

export function isPlaceholderUser(user) {
    return user?.email?.endsWith('@tourminator.local') === true;
}

export function printDate(date) {
    if (date == null) {
        return "";
    }
    //print in dd.MM format

    const format = "dd.MM";
    const options = { month: '2-digit', day: '2-digit' };
    options.timeZone = 'UTC';

    return new Date(date).toLocaleDateString("no", options);




    return new Date(date).toLocaleDateString();
}


export function eventName(event) {
    if (event == null) {
        return "Unknown Event";
    }

    let name = event.name || event.venue?.name || "Unnamed Event";

    // Get location from venue
    const location = event.venue?.eventVenueLocation || event.venue?.location;
    if (location) {
        const city = location.city;
        const country = location.country;
        if (city || country) {
            const cityCountry = [city, country].filter(Boolean).join(', ');
            name = `${name}, ${cityCountry}`;
        }
    }

    return name;
}


export async function getFlightInfo(flightNr, date) {

    console.log("Get flight info:", flightNr, date);
    const airline = flightNr.substring(0, 2);
    const flightNumber = flightNr.substring(2);

    if (date == null) {
        date = new Date();
    }

    const year = date.split("-")[0];
    const month = date.split("-")[1];
    const day = date.split("-")[2].split("T")[0];



    //const url = `https://www.flightstats.com/v2/api-next/flick/1301494220?guid=ss:s:ss:XXXX&airline=${airline}&flight=${flightNumber}&flightPlan=true&rqid=fio35qufhcd`;
    const url = `https://www.flightstats.com/v2/api-next/flight-tracker/${airline}/${flightNumber}/${year}/${month}/${day}/`;
    console.log("Flight URL:", url);
    try {
        const response = await fetch(url);
        const data = await response.json();
        console.log("Flight Data:", data);

        if (data.data) {
            const flight = data.data; // Get first matching flight
            return {
                flightId: flight.flightId,
                timeStart: flight.schedule.scheduledDeparture,
                timeEnd: flight.schedule.scheduledArrival,
                statusDescription: flight.status.statusDescription,
                lastUpdatedText: flight.status.lastUpdatedText,
                departureAirport: flight.departureAirport.iata,
                departureAirportName: flight.departureAirport.name,
                departureAirportCity: flight.departureAirport.city,
                departureAirportCountry: flight.departureAirport.country,
                departureAirportTimezone: flight.departureAirport.timezone,
                arrivalAirport: flight.arrivalAirport.iata,
                arrivalAirportName: flight.arrivalAirport.name,
                arrivalAirportCity: flight.arrivalAirport.city,
                arrivalAirportCountry: flight.arrivalAirport.country,
                arrivalAirportTimezone: flight.arrivalAirport.timezone,
                airline: flight.positional.flexTrack.carrierFsCode,
                flightNumber: flight.positional.flexTrack.flightNumber,
                aircraftType: flight.positional.flexTrack.aircraftType,
            };
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching flight data:", error);
        return null;
    }
}




export const openActivityInMaps = (activity, mode = 'default') => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let mapUrl;

    const formatCoords = (loc) => {
        if (loc.name && loc.address) {
            return encodeURIComponent(`${loc.name}, ${loc.address}, ${loc.city || ''}`);
        }
        return loc.latitude && loc.longitude ? `${loc.latitude},${loc.longitude}` : encodeURIComponent([loc.name, loc.address, loc.city, loc.zipCode, loc.country].filter(Boolean).join(", "));
    };

    const startLoc = activity.startLocation || activity.location;
    const endLoc = activity.endLocation;

    if (mode === 'location' && startLoc) {
        const query = formatCoords(startLoc);
        mapUrl = isMobile ? `comgooglemaps://?q=${query}` : `https://www.google.com/maps/search/?api=1&query=${query}`;
    } else if (mode === 'directions_to_start' && startLoc) {
        const dest = formatCoords(startLoc);
        mapUrl = isMobile ? `comgooglemaps://?daddr=${dest}&directionsmode=driving` : `https://www.google.com/maps/dir/?api=1&destination=${dest}`;
    } else if ((mode === 'route' || mode === 'default') && startLoc && endLoc) {
        const origin = formatCoords(startLoc);
        const destination = formatCoords(endLoc);
        mapUrl = isMobile
            ? `comgooglemaps://?saddr=${origin}&daddr=${destination}&directionsmode=driving`
            : `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`;
    } else if (startLoc) {
        // Fallback for default if no endLoc
        const query = formatCoords(startLoc);
        mapUrl = isMobile ? `comgooglemaps://?q=${query}` : `https://www.google.com/maps/search/?api=1&query=${query}`;
    } else {
        console.warn("Ingen lokasjon å åpne.");
        return;
    }

    if (isMobile) {
        window.location.href = mapUrl;
    } else {
        window.open(mapUrl, "_blank");
    }
};


export const openRideShare = (activity) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Determine destination (usually order TO the activity location)
    // For flights/transport, it might be the start location (getting to the airport)
    // For standard activities (dinner, meeting), it's the activity location itself.
    let destLoc = activity.location || activity.startLocation;

    if (!destLoc) {
        console.warn("No destination location for ride share.");
        return;
    }

    const lat = destLoc.latitude;
    const lng = destLoc.longitude;
    const name = encodeURIComponent(destLoc.name || "");
    const addr = encodeURIComponent(destLoc.address || "");

    if (!lat || !lng) {
        // Fallback to address search if no lat/lng? 
        // Uber universal link supports `dropoff[formatted_address]` but lat/long is better.
        if (destLoc.address || destLoc.name) {
            const query = encodeURIComponent([destLoc.name, destLoc.address, destLoc.city].filter(Boolean).join(", "));
            // Fallback to google maps directions if no coords for reliable uber deep link?
            // Or try uber with just address search.
            const uberWebUrl = `https://m.uber.com/ul/?action=setPickup&pickup=my_location&dropoff[formatted_address]=${query}`;
            window.open(uberWebUrl, "_blank");
            return;
        }
        alert("Missing location coordinates for Ride Share.");
        return;
    }

    // Uber Universal Link
    // client_id is optional for deep linking but good practice if we had one.
    // action=setPickup
    // pickup=my_location (uses device GPS)
    // dropoff[latitude], dropoff[longitude], dropoff[nickname]

    // Web fallback is handled automatically by m.uber.com if app not installed
    const uberUrl = `https://m.uber.com/ul/?action=setPickup&pickup=my_location&dropoff[latitude]=${lat}&dropoff[longitude]=${lng}&dropoff[nickname]=${name}&dropoff[formatted_address]=${addr}`;

    window.open(uberUrl, "_blank");
};


export function activityName(activity) {

    const thisActivityType = ActivityTypes.find(type => type?.value === activity?.type);

    const icon = thisActivityType?.icon;

    const activityName = thisActivityType?.name ? <>{thisActivityType.name}</> : "null";
    let tekst = "";
    if (activity?.activityCrews_on_activity?.length > 0) {
        const users = activity.activityCrews_on_activity.map(c => c.crew.user);
        tekst = users.map(user => printName(user, users)).join(", ");
    }

    let stringTitle = activity?.name;

    if (activity?.type === ActivityType.FLIGHT) {
        stringTitle = `Flight: ${activity.flightNumber || ""}`;
    }

    if (!stringTitle || stringTitle === "") {
        stringTitle = thisActivityType?.name || activity?.type || "Activity";
    }

    return stringTitle;

}

// Helper for returning JSX (used in lists)
export const ActivityNameComponent = ({ activity }) => {
    const thisActivityType = ActivityTypes.find(type => type?.value === activity?.type);
    let stringTitle = activity?.name;

    if (activity?.type === ActivityType.FLIGHT) {
        stringTitle = `Flight: ${activity.flightNumber || ""}`;
    }

    if (!stringTitle || stringTitle === "") {
        stringTitle = thisActivityType?.name || "";
    }

    let color = undefined;
    if (activity?.type === ActivityType.OTHER_ARTIST) {
        color = "grey";
    }

    return (
        <Box display="flex" flexDirection="column" gap={0.5}>
            <Box display="flex" alignItems="center" gap={1}>
                {thisActivityType?.icon && (
                    <Box color="action.active" display="flex" alignItems="center">
                        {thisActivityType.icon}
                    </Box>
                )}
                <Typography variant="body2" fontWeight="bold" color={color} component="span">
                    {stringTitle}
                </Typography>
            </Box>

            {activity?.location && (
                <Typography variant="caption" color="text.secondary" display="block">
                    {activity.endLocation ? "From: " : ""}
                    {activity.location.name}{activity.location.name && activity.location.address ? ', ' : ''}{activity.location.address}
                    {!activity.location.name && !activity.location.address && "Unknown"}
                    {activity.endLocation && (
                        <>
                            {" → "}
                            {activity.endLocation.name}{activity.endLocation.name && activity.endLocation.address ? ', ' : ''}{activity.endLocation.address}
                            {!activity.endLocation.name && !activity.endLocation.address && "Unknown"}
                        </>
                    )}
                    {activity.distance && ` (${activity.distance})`}
                </Typography>
            )}

            {activity?.description && (
                <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    {activity.description}
                </Typography>
            )}
        </Box>
    );
};


export function getTimeInLocalTimeZone(date, timeZone) {
    return moment.tz(date, timeZone).format("YYYY-MM-DD HH:mm:ss");
}



export const parseFlightNumbers = (input) => {
    if (!input || typeof input !== 'string') return [];
    const regex = /\b([A-Za-z]{2,3}|[A-Za-z]\d|\d[A-Za-z])\s*(\d{1,4}[A-Za-z]?)\b/g;
    const matches = [];
    let match;
    while ((match = regex.exec(input)) !== null) {
        matches.push(`${match[1].toUpperCase()}${match[2].toUpperCase()}`);
    }
    if (matches.length > 0) return matches;
    return input
        .split(/[,/;+&]+/)
        .map(s => s.replace(/\s+/g, '').toUpperCase())
        .filter(Boolean);
};

export const searchFlight = async (date, dateTimeZone, flightNumber, options = {}) => {
    const { silent = false } = options;

    const startDate = moment(date).tz(dateTimeZone || "UTC");
    const formattedDate = startDate.format("YYYY-MM-DD");
    flightNumber = flightNumber?.trim();
    let returnDict = {};

    if (!flightNumber) {
        if (!silent) alert("Du må skrive inn flightnummer");
        return null;
    }

    try {
        const getFlightStatusFn = httpsCallable(functions, 'getFlightStatus');
        const result = await getFlightStatusFn({ flightNumber, date: formattedDate });
        const responseData = result.data;

        if (responseData.error || !responseData.data) {
            if (!silent) alert("Ingen flightdata funnet.");
            return null;
        }

        const data = responseData.data;

        if (!Array.isArray(data) || data.length === 0) {
            if (!silent) alert("Ingen flightdata funnet.");
            return null;
        }

        // Use first flight in array
        const flight = data[0];
        // Robustly extract fromLocation and toLocation per shape
        const fromAirport = flight.departure?.airport || {};
        const toAirport = flight.arrival?.airport || {};
        const fromLocation = {
            name: `${fromAirport.name || ""}${fromAirport.iata ? ` (${fromAirport.iata})` : ""}`,
            city: fromAirport.municipalityName || "",
            country: fromAirport.countryCode || "",
            latitude: fromAirport.location?.lat ?? null,
            longitude: fromAirport.location?.lon ?? null,
            googleId: "",
            timeZone: fromAirport.timeZone || "",
        };
        const toLocation = {
            name: `${toAirport.name || ""}${toAirport.iata ? ` (${toAirport.iata})` : ""}`,
            city: toAirport.municipalityName || "",
            country: toAirport.countryCode || "",
            latitude: toAirport.location?.lat ?? null,
            longitude: toAirport.location?.lon ?? null,
            googleId: "",
            timeZone: toAirport.timeZone || "",
        };

        returnDict.location = fromLocation;
        returnDict.endLocation = toLocation;

        // Distance
        if (flight.greatCircleDistance?.km) {
            returnDict.distanceKm = Number(flight.greatCircleDistance.km);
            returnDict.distance = `${flight.greatCircleDistance.km.toFixed(0)} km`;
        }

        // Duration calculation
        if (
            flight.departure?.scheduledTime?.utc &&
            flight.arrival?.scheduledTime?.utc
        ) {
            const dep = moment.utc(flight.departure.scheduledTime.utc);
            const arr = moment.utc(flight.arrival.scheduledTime.utc);
            const mins = arr.diff(dep, "minutes");
            const hrs = Math.floor(mins / 60);
            const rest = mins % 60;
            returnDict.duration = `${hrs}t ${rest}m`;
            returnDict.durationSeconds = Math.max(0, mins * 60);
        }

        // Set start and end times using time zone from response
        const depTz = fromAirport.timeZone;
        const arrTz = toAirport.timeZone;

        if (depTz) returnDict.startTimeZone = depTz;
        if (arrTz) returnDict.endTimeZone = arrTz;

        if (flight.departure?.scheduledTime?.local) {
            const start = moment.parseZone(flight.departure.scheduledTime.local).toDate();
            returnDict.startTimeTs = start;
        }

        if (flight.arrival?.scheduledTime?.local) {
            const end = moment.parseZone(flight.arrival.scheduledTime.local);
            returnDict.endTimeTs = end.toDate();
        }

        if (flight.number) {
            returnDict.flightNumber = flight.number.replace(/\s+/g, '');
        } else {
            returnDict.flightNumber = flightNumber.replace(/\s+/g, '').toUpperCase();
        }

        return returnDict;

    } catch (err) {
        console.error("Feil ved henting av flightinfo:", err);
        return null;
    }
};



export async function fetchWeatherSymbol(lat, lng) {
    const url = `https://api.met.no/weatherapi/locationforecast/2.0/classic?lat=${lat}&lon=${lng}`;
    const response = await fetch(url, {
        headers: {
            "User-Agent": "Tourminator/1.0 eirik@example.com",  // viktig for YR
        }
    });

    if (!response.ok) throw new Error("Failed to fetch weather");

    const text = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(text, "text/xml");

    // Finn første forecast tid og symbol
    const symbol = xmlDoc.querySelector("symbol");
    const symbolName = symbol?.getAttribute("id") || "clearsky_day";

    return symbolName;
}